import { EventBus } from "@/plugins/event-bus";

export default {
  mounted() {
    // Only apply if component has a validate() method (like v-text-field, v-select, etc.)
    if (typeof this.validate === "function") {
      this._revalidateListener = () => {
        this.validate();
      };
      EventBus.$on("revalidate-inputs", this._revalidateListener);
    }
  },
  beforeDestroy() {
    if (this._revalidateListener) {
      EventBus.$off("revalidate-inputs", this._revalidateListener);
      this._revalidateListener = null;
    }
  },
};
